<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="border-4 border-dashed border-gray-200 rounded-lg h-96" />
  </div>
</template>

<script>
export default {
  name: 'admin',
  layout: 'admin',
  beforeCreate() {
    this.$router.push({ path: '/admin/audience' });
  },
};
</script>
